<template>
  <div class="reset-password">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="box">
              <p class="title is-5">{{ $t('password-reset-view.title') }}</p>
              <p class="subtitle">
                {{ $t('password-reset-view.hints') }}
              </p>
              <b-input @keydown.native.enter="resetPassword" v-model="email"
                       :placeholder="$t('password-reset-view.email-placeholder')" tabindex="1"></b-input>
              <b-button @keydown.native.enter="resetPassword" @click="resetPassword" type="is-primary" tabindex="2"
                        style="margin-top: 32px"
                        expanded>{{
                  $t('password-reset-view.send-password-reset-button')
                }}
              </b-button>
              <b-button @click="cancel" tabindex="3" expanded>{{
                  $t('common.cancel')
                }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "PasswordReset",
  data() {
    return {
      email: ""
    };
  },
  methods: {
    resetPassword: function () {
      this.$parent.isLoading = true
      firebase
          .auth()
          .sendPasswordResetEmail(this.email)
          .then(() => {
            this.$parent.isLoading = false
            this.showSuccess(this.$t("password-reset-view.password-reset-sent"))
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message)
          });
    },
    cancel: function () {
      this.$router.back()
    }
  },
  computed: {
    isEmailVerified() {
      return firebase.auth().currentUser.emailVerified
    }
  }
};
</script>

<style scoped>
.reset-password {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  padding: 15px;
}

.subtitle {
  margin-top: 40px;
  font-size: 13px;
}

button {
  margin-top: 10px;
  padding: 15px;
  cursor: pointer;
}
</style>